import React, { useContext, useState } from 'react';
import Panel from 'Components/Panel/Panel';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import Production from './Production/Production';
import BalancingDay from './BalancingDay/BalancingDay';
import OperationInformation from './OperationInformation/OperationInformation';
import { AuthContext } from 'Contexts/auth';

const ProductionBalancing = () => {
    const { user } = useContext(AuthContext);
    const currentModule = user.module == 'OCMT_PRD_BLCT' || user.module == 'OCMT_PRD_BLCT_QTRZ';

    const [productionIdSelecteds, setProductionIdSelected] = useState([])
    const [productionDaysIdSelecteds, setProductionDaysIdSelecteds] = useState([]);
    const [reloadProductionList, setReloadProductionList] = useState(false)
    const [decreaseProductionPanel, setDecreaseProductionPanel] = useState(false);
    const [decreaseProductionPanelDay, setDecreaseBalancingDay] = useState(false);
    const [showEmployeesAllocated, setShowEmployeesAllocated] = useState(false);
    const [showExternalProduction, setShowExternalProduction] = useState(false);

    const mainStyle = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        overflow: 'hidden'
    };

    function setProductionIdSelectedsAndOpen(value) {
        if (value.length == 1 && productionIdSelecteds.length == 1 && value[0] == productionIdSelecteds[0]) {
            return;
        }
        if (decreaseProductionPanel != false && (value.length != 1)) {
            setDecreaseProductionPanel(false)
        }
        setProductionIdSelected(value)
        setProductionDaysIdSelecteds([])
    }

    return (
        <LayoutDefault>
            <Panel style={mainStyle}>
                <Production
                    onUpdateProductionIdSelected={setProductionIdSelectedsAndOpen}
                    onUpdateReloadProductionList={setReloadProductionList}
                    onUpdateDecreaseProductionPanel={setDecreaseProductionPanel}
                    onUpdateProductionDaysIdSelecteds={setProductionDaysIdSelecteds}
                    productionIdSelecteds={productionIdSelecteds}
                    reloadProductionList={reloadProductionList}
                    decreaseProductionPanel={decreaseProductionPanel}
                    decreaseProductionPanelDay={decreaseProductionPanelDay}
                    allowedAdvancedModule={currentModule}
                    onUpdateShowEmployesDayAllocatedPanel={setShowEmployeesAllocated}
                    showEmployesDayAllocatedPanel={showEmployeesAllocated}
                    showExternalProduction={showExternalProduction}
                    onUpdateShowExternalProduction={setShowExternalProduction}
                />
                <OperationInformation
                    onUpdateDecreaseProductionPanel={setDecreaseProductionPanel}
                    onUpdateReloadProductionList={setReloadProductionList}
                    onUpdateProductionDaysIdSelecteds={setProductionDaysIdSelecteds}
                    onUpdateDecreaseProductionPanelDay={setDecreaseBalancingDay}
                    productionIdSelecteds={productionIdSelecteds}
                    productionDaysIdSelecteds={productionDaysIdSelecteds}
                    decreaseProductionPanel={decreaseProductionPanel}
                    decreaseProductionPanelDay={decreaseProductionPanelDay}
                    reloadProductionList={reloadProductionList}
                    allowedAdvancedModule={currentModule}
                    onUpdateShowEmployesDayAllocatedPanel={setShowEmployeesAllocated}
                />
                <BalancingDay
                    onUpdateReloadProductionList={setReloadProductionList}
                    onUpdateDecreaseProductionPanelDay={setDecreaseBalancingDay}
                    productionDaysIdSelecteds={productionDaysIdSelecteds}
                    decreaseProductionPanelDay={decreaseProductionPanelDay}
                    mainPanel={true}
                />
            </Panel>
        </LayoutDefault>
    );
};

export default ProductionBalancing;
